var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "remove_svg__a",
    d: "M10 8.683l3.394-3.393c.878-.878 2.194.438 1.316 1.316l-4.052 4.052a.931.931 0 01-1.316 0L5.29 6.606c-.878-.878.438-2.194 1.316-1.316L10 8.683zm0 2.634L6.606 14.71c-.878.878-2.194-.438-1.316-1.316l4.052-4.052a.931.931 0 011.316 0l4.052 4.052c.878.878-.438 2.194-1.316 1.316L10 11.317z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#remove_svg__a"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0xMCA4LjY4M2wzLjM5NC0zLjM5M2MuODc4LS44NzggMi4xOTQuNDM4IDEuMzE2IDEuMzE2bC00LjA1MiA0LjA1MmEuOTMxLjkzMSAwIDAgMS0xLjMxNiAwTDUuMjkgNi42MDZjLS44NzgtLjg3OC40MzgtMi4xOTQgMS4zMTYtMS4zMTZMMTAgOC42ODN6bTAgMi42MzRMNi42MDYgMTQuNzFjLS44NzguODc4LTIuMTk0LS40MzgtMS4zMTYtMS4zMTZsNC4wNTItNC4wNTJhLjkzMS45MzEgMCAwIDEgMS4zMTYgMGw0LjA1MiA0LjA1MmMuODc4Ljg3OC0uNDM4IDIuMTk0LTEuMzE2IDEuMzE2TDEwIDExLjMxN3oiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiNDQ0MiLz48dXNlIGZpbGw9IiNGRkYiIHhsaW5rOmhyZWY9IiNhIi8+PC9nPjwvc3ZnPg==";
export { SvgRemove as ReactComponent };